/* React-Redux */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Cookies */
import Cookies from "js-cookie";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Utils */
import { ClientError } from "src/utils/status-handling/ClientError";

/* Interfaces */
import { AuthProps } from "src/shared/interfaces/common/Auth";
import { TokenType } from "src/shared/interfaces/api/Token";

export const logoutWithRefreshToken = createAsyncThunk<
  AuthProps,
  void,
  { rejectValue: ClientError }
>(
  "logoutWithRefreshToken",
  async (_, { rejectWithValue }) => {
    await axiosInterceptor.get("/logout");
    try {
      Cookies.remove(TokenType.ACCESS_TOKEN);
      Cookies.remove(TokenType.REFRESH_TOKEN);

      return {
        isAuthenticated: false,
        expirationTime: null,
      };
    } catch (error) {
      return rejectWithValue(ClientError.internal());
    }
  }
);
